// Deterministic calculation-register fixture shared by the preview harness and
// the help articles that explain it. Counts and named examples in prose are
// derived from this module so a fixture edit cannot silently leave the article
// describing a different register.

export const REGISTER_FIXTURE = {
  sheets: [
    {
      id: "fj1",
      calculatorId: "wood_beam_asd",
      name: "FJ-1",
      role: "floor_joist",
      callout: "2x10",
      species: "DF-L",
      grade: "No.2",
      maxDcr: 0.72,
      passes: true,
      status: "ready",
      governing: "D+L",
      groupId: "level-2",
    },
    {
      id: "fj2",
      calculatorId: "wood_beam_asd",
      name: "FJ-2",
      role: "floor_joist",
      callout: "2x12",
      species: "DF-L",
      grade: "No.2",
      maxDcr: 0.64,
      passes: true,
      status: "ready",
      governing: "D+L",
      groupId: "level-2",
    },
    {
      id: "b1",
      calculatorId: "wood_beam_asd",
      name: "B-1",
      role: "beam",
      callout: "3.5x11.875 LVL",
      species: "LVL",
      grade: "2.0E",
      maxDcr: 0.91,
      passes: true,
      status: "ready",
      governing: "D+L",
      groupId: "level-2",
    },
    {
      id: "h2",
      calculatorId: "wood_beam_asd",
      name: "H-2",
      role: "header",
      callout: "1.75x11.875 LVL",
      species: "LVL",
      grade: "2.0E",
      maxDcr: 1.03,
      passes: false,
      status: "ready",
      governing: "D+S",
      groupId: "level-2",
    },
    {
      id: "st1",
      calculatorId: "wood_stud_wall_asd",
      name: "ST-1",
      role: "stud",
      callout: "2x6",
      species: "DF-L",
      grade: "No.2",
      maxDcr: 0.68,
      passes: true,
      status: "ready",
      governing: "D+W",
      groupId: "vertical",
    },
    {
      id: "p1",
      calculatorId: "wood_column_asd",
      name: "P-1",
      role: "post",
      callout: "6x6",
      species: "DF-L",
      grade: "No.2",
      maxDcr: 0.61,
      passes: true,
      status: "ready",
      governing: "D+L",
      groupId: "vertical",
    },
    {
      id: "cn2",
      calculatorId: "wood_nail_connection_asd",
      name: "CN-2",
      role: "connection",
      callout: "3 toe-nails",
      species: "Wood",
      grade: "NDS",
      maxDcr: 1.42,
      passes: false,
      status: "ready",
      governing: "D+S",
      groupId: "connections",
    },
    {
      id: "lw1",
      calculatorId: "load_wind_mwfrs",
      name: "WM-1",
      role: "loading",
      callout: "Wind MWFRS",
      species: "",
      grade: "ASCE 7",
      maxDcr: null,
      passes: null,
      status: "draft",
      governing: null,
      groupId: "ungrouped",
    },
  ],
  groups: [
    { id: "level-2", label: "Level 2 framing" },
    { id: "vertical", label: "Vertical + walls" },
    { id: "connections", label: "Connection details" },
  ],
} as const;

export const REGISTER_ROLLUP = {
  total: REGISTER_FIXTURE.sheets.length,
  failing: REGISTER_FIXTURE.sheets.filter((sheet) => sheet.passes === false).length,
  near: REGISTER_FIXTURE.sheets.filter(
    (sheet) => sheet.maxDcr != null && sheet.maxDcr >= 0.9 && sheet.maxDcr <= 1,
  ).length,
  pending: REGISTER_FIXTURE.sheets.filter(
    (sheet) => sheet.passes == null && sheet.maxDcr == null,
  ).length,
} as const;

export const REGISTER_GROUP_COUNTS = Object.fromEntries(
  [...REGISTER_FIXTURE.groups, { id: "ungrouped", label: "Ungrouped" }].map((group) => [
    group.id,
    REGISTER_FIXTURE.sheets.filter((sheet) => sheet.groupId === group.id).length,
  ]),
) as Record<string, number>;
